/**
 * @file index.tsx
 *
 * @fileoverview Renders HTML figure with caption.
 */
import { ReactNode } from "react";
import styles from "./figure.module.scss";

interface FigureProps {
  /**
   * The caption text.
   */
  caption: string;
  /**
   * The additional className.
   */
  className?: string;
  /**
   * The child element to display.
   */
  children: ReactNode;
}
export default function Figure({
  caption,
  children,
  className = "",
}: FigureProps) {
  return (
    <figure className={`${styles.figure} ${className}`}>
      {children}
      <figcaption className={styles.caption}>{caption}</figcaption>
    </figure>
  );
}
export { Figure };
